import { formatShortDateRange } from '@elara/client-core/lib/date-utils';
import { pluralize } from '@elara/client-core/lib/utils';

/**
 * Opens one destination's run of days in the full-page "Trip overview" list — the same split the
 * itinerary builder makes, so a multi-destination trip reads as Kyoto, then Osaka. Shared by the
 * owner's itinerary and the public shared itinerary.
 */
export function OverviewDestinationHeader({
  label,
  startDateKey,
  endDateKey,
  dayCount,
}: {
  label: string;
  startDateKey: string;
  endDateKey: string;
  /** Days in the section; nights are one fewer, as in the builder. */
  dayCount: number;
}) {
  const nights = Math.max(0, dayCount - 1);
  const dateRange = formatShortDateRange(startDateKey, endDateKey);

  return (
    <div className="flex flex-col gap-0.5">
      <h4 className="text-xl font-display">{label}</h4>
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        {dateRange && <span>{dateRange}</span>}
        {nights > 0 && (
          <>
            {dateRange && <span>&bull;</span>}
            <span>
              {nights} {pluralize(nights, 'night')}
            </span>
          </>
        )}
      </div>
    </div>
  );
}
